import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import { DatePicker, Flex, Input, Select, Typography, Upload, Button, message } from 'antd'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { clubDocumentsAction, editFile } from 'src/store/Slices/Documents/ClubDocumentsSlice'
import { openNotification } from 'src/components/helpers/notification';
import { UploadOutlined } from '@ant-design/icons';
import { base64ToArrayBuffer } from 'src/components/helpers/downloadReport'
import axios from 'axios'
import { baseUrl } from 'src/store/config'

const EditClubDocumentModal = ({ visible, setVisible, documentInfo }) => {

    // HELPERS
    const dispatch = useDispatch()
    const token = localStorage.getItem('accessToken')

    // STATE
    const [fileList, setFileList] = useState([]);
    const [uploading, setUploading] = useState(false);
    console.log(fileList);
    console.log(documentInfo);
    const handleUpload = async() => {
        const formData = new FormData();
        fileList.forEach((file) => {
            formData.append('document', file);
        });
        formData.append('Id', documentInfo?.id)
        for (let [key, value] of formData.entries()) {
            console.log(key, value);
        }
        console.log(formData)
        setUploading(true);
        dispatch(editFile(formData))
        .then(() => {
            setVisible(false);
            setFileList([]);
            setUploading(false);
            dispatch(clubDocumentsAction({flag: 'get'}))
        })
    };

    const handleChange = (info) => {
        if (info.fileList.length === 0) {
            setFileList([])
        } else {
            let newFileList = [...fileList];
            newFileList = newFileList.slice(-1);
            setFileList(newFileList);
        }
 
    };


    const props = {
        onRemove: () => {
            setFileList([])
        },
        onChange: handleChange,
        beforeUpload: (file) => {
            setFileList([...fileList, file]);
            return false;
        },
        fileList,
    };

    useEffect(() => {
        setFileList([])
        setUploading(false)
    }, [documentInfo])


    return (
        <CModal
            alignment="center"
            visible={visible}
            aria-labelledby="VerticallyCenteredExample"
            onClose={() => { setVisible(false) }}
            keyboard={true}
        >
            <CModalHeader>
                <CModalTitle id="VerticallyCenteredExample">{
                    'Редактировать документ'
                }</CModalTitle>
            </CModalHeader>
            <CModalBody style={{ display: 'flex', justifyContent: 'center', flexDirection: 'row' }}>
                    <Upload accept='.pdf' {...props}>
                        <Button icon={<UploadOutlined />}>Выберите файл</Button>
                    </Upload>
            </CModalBody>
            <CModalFooter>
                <CButton
                    onClick={() => { setVisible(false) }}
                    style={{ color: '#fff' }}
                    color="secondary"
                >
                    Закрыть
                </CButton>
                <CButton onClick={handleUpload} disabled={fileList.length === 0} loading={uploading} style={{ color: '#fff' }}>
                    {uploading ? 'Загрузка...' : 'Редактировать'}
                </CButton>
            </CModalFooter>
        </CModal>
    )
}

export default EditClubDocumentModal